import getImageById from 'editor/src/store/gallery/selector/getImageById';
import { ImageState } from 'editor/src/store/gallery/types';
import type { Thunk } from 'editor/src/store/hooks';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

import { getLibraryRequest, isImageSaved, isLibraryEnabled } from '../selector';
import { setLibraryRequestAction } from '../slice';

import failUnansweredLibraryRequestOperation from './failUnansweredLibraryRequestOperation';

/**
 * Asks the host to save a gallery image the host marked as the customer's own; a second click while the host is
 * busy sends nothing.
 */
const saveImageToLibraryOperation =
  (imageId: string): Thunk =>
  (dispatch, getState) => {
    const state = getState();
    const image = getImageById(state, imageId);
    if (
      !isLibraryEnabled(state) ||
      isImageSaved(state, imageId) ||
      getLibraryRequest(state, imageId)?.status === 'pending' ||
      image?.state !== ImageState.UPLOADED ||
      image.savableToLibrary !== true
    ) {
      return;
    }

    dispatch(setLibraryRequestAction({ imageId, request: { status: 'pending', saved: true } }));
    sendPostMessage('gallery.saveToLibrary', { imageId });
    dispatch(failUnansweredLibraryRequestOperation(imageId));
  };

export default saveImageToLibraryOperation;
